import React from 'react';
import { SelectList } from 'react-native-dropdown-select-list';
import { View, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@rneui/themed';

const styles = StyleSheet.create({
    selectArea: {
        width: '100%',
    },
    boxStyle: {
        width: '100%',
    },
    inputStyle: {
        width: '100%',
    },
    dropdownStyle: {
        width: '100%',
    },
    dropdownTextStyle: {
        width: '100%',
    },
});

interface Props {
    value: string;
    setFieldValue: any;
    selectItems: any;
    style?: any;
}

const Select: React.FC<Props> = ({
    value,
    setFieldValue,
    selectItems,
    style,
}: Props) => {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const [selected, setSelected] = React.useState<string | null>(null);

    return (
        <View style={style.selectArea}>
            <SelectList
                onSelect={() => {
                    setFieldValue(selected);
                }}
                setSelected={(val: string) => {
                    setSelected(val);
                }}
                data={selectItems}
                placeholder={t('language')}
                save="value"
                search={false}
                boxStyles={[style.boxStyle, { color: theme.colors.primary }]}
                inputStyles={[style.inputStyle, { color: theme.colors.text }]}
                dropdownStyles={style.dropdownStyle}
                dropdownTextStyles={[
                    style.dropdownTextStyle,
                    { color: theme.colors.text },
                ]}
                defaultOption={
                    value !== null ? { key: value, value } : undefined
                }
            />
        </View>
    );
};

Select.defaultProps = {
    value: '',
    style: styles,
};

export default Select;
